(function () {
  "use strict";

  const template = document.createElement("template");
  template.innerHTML = `
  <style>
  [data-active],
  li:hover {
    background-color: #CCCCCC;
  }
  input {
    appearance: none;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    color: rgb(var(--color-foreground));
    font-size: 1.6rem;
    width: 100%;
    box-shadow: 0 0 0 .1rem rgba(var(--color-foreground),.55);
    height: 4.5rem;
    box-sizing: border-box;
    transition: box-shadow var(--duration-short) ease;
    line-height: 1.5;
    letter-spacing: .04rem;
    flex-grow: 1;
    text-align: left;
    padding: 1.5rem;
  }
  input::placeholder {
    color: rgba(var(--color-foreground),.8);
  }
  ul {
    display: block;
    position: absolute;
    top: 46px;
    width: 100%;
    background-color: #fff;
    font-weight: 300;
    font-size: 1.5rem;
    z-index: 2;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  li {
    text-align: left;
    color: #000;
    cursor: pointer;
    padding: 10px 15px;
    border-bottom: 1px solid #000;
  }
  li:hover {

  }
  div {
    position: relative;
  }
  </style>
  <div>
    <input type="text" placeholder="Gib deine Adresse ein..." autocomplete="off">
    <ul></ul>
  </div>
`;
  const COLLECTION_MAP = {
    Berlin: "/collections/berlin",
    München: "/collections/munchen",
    Hamburg: "/collections/hamburg",
  };

  function debounce(callback, wait) {
    let timeout;
    return function (...Rest) {
      clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        clearTimeout(timeout);
        callback(...Rest);
      }, wait);
    };
  }

  class AutocompleteInput extends HTMLElement {
    constructor() {
      super();

      this._shadow = this.attachShadow({ mode: "open" });
      this._shadow.appendChild(template.content.cloneNode(true));

      this._body = document.querySelector("body");
      this._input = this._shadow.querySelector("input");
      this._suggestionList = this._shadow.querySelector("ul");
      this._currentSuggestions = [];

      this.mapboxClient = mapboxSdk({
        accessToken:
          "pk.eyJ1IjoiZmVsaXhzdG9jayIsImEiOiJjam4xZXI4dnI0azFxM3hxY3Iza2R2cWhrIn0.C8cIJGklRSy5W4gkrSJaCg",
      });
    }

    connectedCallback() {
      this.handleAutocompleteInput = debounce(
        this.handleAutocompleteInput,
        300
      );

      this._input.addEventListener("input", this.handleAutocompleteInput);
      this._input.addEventListener(
        "keydown",
        this.handleAutocompleteListSelection
      );
      this._body.addEventListener("click", this.closeSuggestionList.bind(this));
    }

    disconnectedCallback() {
      this._input.removeEventListener("input", this.handleAutocompleteInput);
      this._input.removeEventListener(
        "keydown",
        this.handleAutocompleteListSelection
      );
      this._body.removeEventListener("click", this.closeSuggestionList);
    }

    handleAutocompleteInput = (evt) => {
      evt.preventDefault();

      this.mapboxClient.geocoding
        .forwardGeocode({
          mode: "mapbox.places",
          language: ["de-DE"],
          query: this._input.value,
        })
        .send()
        .then((response) => {
          this._currentSuggestions = response.body.features.map((feature) => ({
            value: feature.center,
            label: feature.place_name,
            placeName: feature["place_name_de-DE"],
          }));
          this.update();
        });
    };

    // TODO: Make NodeList to enable clicking.
    update() {
      this._suggestionList.innerHTML = "";
      this._currentSuggestions.forEach((item) => {
        const li = document.createElement("li");
        li.setAttribute("data-coordinates", item.value.join(","));
        li.setAttribute("data-place-name", item.placeName);
        li.addEventListener("click", (e) => {
          this.redirectAfterSelection(e.target);
        });
        li.innerText = item.label;

        this._suggestionList.appendChild(li);
      });
      this._suggestionList;
    }

    handleAutocompleteListSelection = (event) => {
      if (!this._currentSuggestions.length) return;
      if (["ArrowDown", "ArrowUp", "Enter", "Escape"].indexOf(event.key) < 0)
        return;

      const allSuggestions = Array.from(
        this._suggestionList.querySelectorAll("li")
      );
      let activeSuggestionIndex = allSuggestions.findIndex((el) =>
        el.hasAttribute("data-active")
      );

      if (event.key === "ArrowDown") {
        if (activeSuggestionIndex < 0) {
          activeSuggestionIndex = 0;
          allSuggestions[activeSuggestionIndex].setAttribute(
            "data-active",
            "true"
          );
          return;
        }

        allSuggestions[activeSuggestionIndex].removeAttribute("data-active");
        activeSuggestionIndex = activeSuggestionIndex + 1;

        if (activeSuggestionIndex >= allSuggestions.length) {
          activeSuggestionIndex = 0;
        }

        allSuggestions[activeSuggestionIndex].setAttribute(
          "data-active",
          "true"
        );
        // TODO
        // this._input.value = allSuggestions[activeSuggestionIndex].value;
      } else if (event.key === "ArrowUp") {
        if (activeSuggestionIndex < 0) {
          activeSuggestionIndex = allSuggestions.length - 1;
          allSuggestions[activeSuggestionIndex].setAttribute(
            "data-active",
            "true"
          );
          return;
        }

        allSuggestions[activeSuggestionIndex].removeAttribute("data-active");
        activeSuggestionIndex = activeSuggestionIndex - 1;

        if (activeSuggestionIndex < 0) {
          activeSuggestionIndex = allSuggestions.length - 1;
        }

        allSuggestions[activeSuggestionIndex].setAttribute(
          "data-active",
          "true"
        );
      } else if (event.key === "Enter") {
        if (activeSuggestionIndex < 0) return;

        const currentSuggestion = allSuggestions[activeSuggestionIndex];
        this.redirectAfterSelection(currentSuggestion);
      } else if (event.key === "Escape") {
        this.closeSuggestionList();
      }
    };

    redirectAfterSelection = (currentSuggestion) => {
      const placeName = currentSuggestion.getAttribute("data-place-name");
      const coordinates = currentSuggestion.getAttribute("data-coordinates");
      const placeNameInCollection = Object.keys(COLLECTION_MAP).find((key) =>
        placeName.includes(key)
      );

      if (placeNameInCollection) {
        window.location.href = COLLECTION_MAP[placeNameInCollection];
      } else {
        const [lon, lat] = coordinates.split(",");
        window.location.href = `/pages/neuland-in-sicht?lon=${lon}&lat=${lat}`;
      }
    };

    closeSuggestionList() {
      this._suggestionList.innerHTML = "";
    }
  }

  customElements.define("autocomplete-input", AutocompleteInput);
})();
